import React from "react";
import { Form } from "react-bootstrap";
import { fonts } from "./consts";
import Select from "react-select";

// 24 base colors hex codes
const baseColors = [
  "#808080", // Gray
  "#000000", // Black
  "#FFFFFF", // White
  "#D3D3D3", // Light Gray
  "#A9A9A9", // Dark Gray
  "#FF0000", // Red
  "#00FF00", // Green
  "#0000FF", // Blue
  "#FFFF00", // Yellow
  "#00FFFF", // Cyan
  "#FF00FF", // Magenta
  "#FFA500", // Orange
  "#800080", // Purple
  "#FFC0CB", // Pink
  "#A52A2A", // Brown
  "#008080", // Teal
  "#000080", // Navy Blue
  "#808000", // Olive
  "#800000", // Maroon
  "#FFD700", // Gold
  "#C0C0C0", // Silver
  "#F5F5DC", // Beige
  "#FF7F50", // Coral
  "#40E0D0", // Turquoise
];

export default function Editor({
  font = null,
  setFont = (font) => {},
  textSize = 100,
  setTextSize = (textSize) => {},
  color = "#FFFFFF",
  setColor = (color) => {},
}) {
  return (
    <div className="flex flex-col gap-3">
      <div>
        <Form.Group>
          <Form.Label>Font</Form.Label>
          <Select
            options={fonts}
            defaultValue={fonts[0]}
            styles={{
              option: (provided, { data }) => ({
                ...provided,
                fontFamily: data.value,
              }),
              singleValue: (provided, { data }) => ({
                ...provided,
                fontFamily: data.value,
              }),
            }}
            value={fonts.find((item) => item.value === font)}
            onChange={(option) => {
              setFont(option.value);
            }}
          />
        </Form.Group>

        <div>
          <small>
            Nếu font bị lỗi, bạn hãy chọn font khác thử rồi chọn lại nhé!
          </small>
        </div>
      </div>
      <div>
        <Form.Group>
          <Form.Label>Kích cỡ</Form.Label>
          <Form.Control
            type={"number"}
            value={textSize}
            min={20}
            max={200}
            step={1}
            onChange={(e) => setTextSize(e.target.value)}
          />
        </Form.Group>
        <div>
          <small>
            Nếu bạn bị mất vài chữ cuối, hãy chỉnh lại kích thước chữ nhỏ hơn
            nhé!
          </small>
        </div>
      </div>
      <div>
        <Form.Group>
          <Form.Label>Màu sắc</Form.Label>
          <div className="grid grid-cols-8 gap-1">
            {baseColors.map((item, index) => (
              <button
                type="button"
                key={index}
                className="bg-gray-200 rounded-full aspect-square cursor-pointer border-slate-500 border-2 p-0 m-0 shadow-sm"
                style={{ backgroundColor: item }}
                onClick={() => setColor(item)}
              ></button>
            ))}
          </div>
          <div className="my-2">hoặc tùy chọn</div>
          <Form.Control
            type={"color"}
            value={color}
            min={60}
            max={200}
            step={1}
            onChange={(e) => setColor(e.target.value || "#FFFFFF")}
          />
        </Form.Group>
      </div>
    </div>
  );
}
